import React from 'react';
import DashboardCard from './DashboardCard';

const LOW_ACTIVITY_PERCENT = 30;

function LiveCohortHealth({ cohorts }) {
  return (
    <DashboardCard
      title="Live cohort health"
      subtitle={`Share of members who logged in during the last 7 days. Cohorts under ${LOW_ACTIVITY_PERCENT}% are flagged.`}
    >
      {cohorts.length === 0 ? (
        <p className="text-sm text-gray-500">No cohorts are running today.</p>
      ) : (
        <div className="overflow-x-auto -mx-5">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wide text-gray-500 bg-gray-50 border-y border-gray-200">
                <th className="py-2 pl-5 pr-2 font-medium">Cohort</th>
                <th className="py-2 px-2 font-medium text-right">Members</th>
                <th className="py-2 px-2 font-medium w-2/5">Active (7d)</th>
                <th className="py-2 pl-2 pr-5 font-medium text-right">
                  Certificates
                </th>
              </tr>
            </thead>
            <tbody>
              {cohorts.map((cohort) => {
                const isLow = cohort.active_7d_percent < LOW_ACTIVITY_PERCENT;
                return (
                  <tr
                    key={cohort.id}
                    className="border-b border-gray-100 last:border-0 hover:bg-gray-50"
                  >
                    <td className="py-3 pl-5 pr-2">
                      <div className="flex items-center gap-2">
                        <span className="text-gray-900">{cohort.name}</span>
                        {isLow && (
                          <span className="shrink-0 rounded-full bg-red-100 text-red-700 text-[10px] font-medium px-2 py-0.5">
                            Low activity
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="py-3 px-2 text-right tabular-nums text-gray-700">
                      {cohort.members.toLocaleString()}
                    </td>
                    <td className="py-3 px-2">
                      <div className="flex items-center gap-3">
                        <div className="flex-1 h-1.5 bg-gray-100 rounded-full overflow-hidden">
                          <div
                            className={`h-full rounded-full ${
                              isLow ? 'bg-red-500' : 'bg-persian-500'
                            }`}
                            style={{
                              width: `${Math.min(
                                cohort.active_7d_percent,
                                100
                              )}%`,
                            }}
                          />
                        </div>
                        <span className="w-24 text-right text-xs tabular-nums text-gray-700 whitespace-nowrap">
                          <span className="font-semibold">
                            {cohort.active_7d_percent}%
                          </span>{' '}
                          <span className="text-gray-400">
                            ({cohort.active_7d.toLocaleString()})
                          </span>
                        </span>
                      </div>
                    </td>
                    <td className="py-3 pl-2 pr-5 text-right tabular-nums text-gray-700">
                      {cohort.certificates_issued.toLocaleString()}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </DashboardCard>
  );
}

export default LiveCohortHealth;
